import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  saveAuthData,
  saveUserData,
} from "../../features/login/LoginSlice";

export const useLoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authToken = useSelector(
    (state) => state.loginSlice.authData?.accessToken
  );
  const { authData } = useSelector((state) => state.loginSlice);

  const handleAuthFlow = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const auth = JSON.parse(queryParams.get("auth"));
    const navbar = queryParams.get("navbar") ? [] : [];
    const authorizations = JSON.parse(queryParams.get("authorization"));
    const isAdmin = JSON.parse(queryParams.get("isAdmin"));

    const secondAppUrl = `${'https://identitysaas.ondchub.com'}/login`;
    // console.log("userDetails",userDetails);
    
    if (!authToken && !auth) {
      const redirectUrl = window.location.origin + window.location.pathname;
      const applicationName = "RSF";

      window.location.href = `${secondAppUrl}?redirectUrl=${encodeURIComponent(
        redirectUrl
      )}&appName=${encodeURIComponent(applicationName)}`;
      return;
    }

    
    const userDetails = {
      ...auth?.user,
      permissions: authorizations || [],
      isAdmin: isAdmin || false,
    };
    dispatch(
      saveAuthData({
        accessToken: auth?.accessToken,
        refreshToken: auth?.refreshToken,
      })
    );
    
    dispatch(saveUserData(userDetails));

    navigate("/");
  };

  return {
    handleAuthFlow,
  };
};
